import React from 'react';

import RepeatIcon from '@material-ui/icons/Repeat';
import styled from 'styled-components';
import { FlexContainer, StyledTooltip, StyledTypography } from 'styles/common';

import { REPEATING_TASK_TEXT } from 'constants/ProjectConstants';
import { StyledIcon, ChatBubbleIcon, CheckListIcon } from 'constants/icons';
import theme from 'constants/theme';

function RepitionStat() {
  return (
    <StyledTooltip title={REPEATING_TASK_TEXT}>
      <StyledIcon size="tiny" color={theme.palette.icons.grey2}>
        <RepeatIcon />
      </StyledIcon>
    </StyledTooltip>
  );
}

function CommentStat({ discussionCommentsCount }) {
  return (
    <>
      <ChatBubbleIcon size="tiny" color={theme.palette.icons.grey2} />
      <StyledTypography color={theme.palette.text.label} leftGutter={0.5} variant="body2">
        {discussionCommentsCount}
      </StyledTypography>
    </>
  );
}

function SubTaskStat({ totalSubtasks, completedSubTasks }) {
  return (
    <FlexContainer style={{ marginLeft: '1rem' }}>
      <CheckListIcon size="tiny" color={theme.palette.icons.grey2} />
      <StyledTypography color={theme.palette.text.label} leftGutter={0.8} variant="body2">
        {`${completedSubTasks}/${totalSubtasks}`}
      </StyledTypography>
    </FlexContainer>
  );
}

export default function TaskStats({
  isEditing,
  isRecurrent,
  discussionCommentsCount = 0,
  totalSubtasks = 0,
  completedSubTasks,
}) {
  return (
    <Container className="taskStatsContainer">
      {!isEditing && isRecurrent && <RepitionStat />}

      {!isEditing && discussionCommentsCount > 0 && <CommentStat discussionCommentsCount={discussionCommentsCount} />}

      {!isEditing && totalSubtasks > 0 && (
        <SubTaskStat totalSubtasks={totalSubtasks} completedSubTasks={completedSubTasks} />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;
